export const formatCurrency = (value: number | string | null | undefined): string => {
  if (!value && value !== 0) return '-';
  const numValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d]/g, '')) : value;
  if (isNaN(numValue)) return '-';
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(numValue);
};

export const formatDate = (date: string | null | undefined): string => {
  if (!date) return '-';
  try {
    return new Date(date).toLocaleDateString('id-ID', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return date;
  }
};
